import { render } from "./Modal2fa.vue?vue&type=template&id=20a9fb80&scoped=true"
import script from "./Modal2fa.vue?vue&type=script&lang=js"
export * from "./Modal2fa.vue?vue&type=script&lang=js"

import "./Modal2fa.vue?vue&type=style&index=0&id=20a9fb80&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a9fb80"]])

export default __exports__